import type { BlockStdScope } from '@blocksuite/affine/block-std';
import { getPopperPosition } from '@blocksuite/affine/blocks';
import { DisposableGroup, throttle } from '@blocksuite/affine/global/utils';
import { getCurrentNativeRange } from '@blocksuite/affine-shared/utils';

import { DocnboardChatPanel } from '../components';

export const askAICommand = (std: BlockStdScope) => {
  const selection = document.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  const range = selection.getRangeAt(0);

  const selectedElements = std.range.getSelectedBlockComponentsByRange(range, {
    mode: 'flat',
  });

  const host = std.host;

  const curRange = getCurrentNativeRange();
  if (!curRange) return;

  const disposables = new DisposableGroup();

  const abortController = new AbortController();
  abortController.signal.addEventListener('abort', () => disposables.dispose());

  const chatPanel = new DocnboardChatPanel();
  chatPanel.model = std.doc.getBlocksByFlavour('affine:note')[0].model;
  chatPanel.abortController = abortController;
  chatPanel.host = host;
  chatPanel.selectedElements = selectedElements;
  const updatePosition = throttle(() => {
    const chatPanelAI = chatPanel.chatPanelAI;
    const position = getPopperPosition(chatPanelAI, curRange);
    chatPanel.updatePosition(position);
  }, 10);

  chatPanel.onMounted = updatePosition;

  disposables.add(() => chatPanel.remove());

  disposables.addFromEvent(window, 'resize', updatePosition);

  document.body.append(chatPanel);
};
